/****
 * Program maintenance
 */
import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment';
import withStyles from '@mui/styles/withStyles';
import { Button, FormControl, Grid, InputLabel, IconButton, Link, MenuItem, Paper,
   Select, Snackbar, SnackbarContent, Tab, Table, TableBody, TableCell, TableHead,
   TableRow, Tabs, TextField, Typography, Dialog, DialogContent, DialogTitle } from '@mui/material';
// import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import Settings from '@mui/icons-material/Settings';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import CloseIcon from '@mui/icons-material/Close'
import ArticleIcon from '@mui/icons-material/Article';

import classNames from 'classnames';

import PageTitle from '../ui/PageTitle';
import VppUpdateMutation from './VppUpdateMutation';
// import ProgramSettingsAsset from './ProgramSettingsAsset';
import ProgramSettingsStage from './ProgramSettingsStage';
// import VendorPartnerProgram from './VendorPartnerProgram';

import ConfirmationDialog from '../ui/ConfirmationDialog';
import LoadingSpinner from '../ui/LoadingSpinner';
import SavingSpinner from '../ui/SavingSpinner'
import ServerError from '../ui/ServerError';
import AppBindStyles from '../../AppBindStyles';
import FormCreateDialog from '../forms/FormCreateDialog';
import { Close, Delete, Pageview } from '@mui/icons-material';
import { green } from '@mui/material/colors';
import FormDeleteMutation from '../forms/FormDeleteMutation';
import FormPreview from '../forms/FormPreview';

const abEnvironment = new AbEnvironment();
const ProgramSettingsAdminQuery = graphql`
query ProgramSettingsAdminQuery($vendorId: UUID!) {
  allVppTs(condition: {vendorId : $vendorId}) {
    totalCount
    nodes {
      vppId
      description
      programName
      visibility
      notes
      formId
      repFname
      repLname
      repEmail
      repImg
      defaultParmValue
    }
  }
	allFormTs (condition: {accountId : $vendorId}) {
    nodes {
   		formId
      formName
      formTitle
      formSubtitle
      description
      created
      updated
    }
  }
  allAccountLandingTs (condition: {accountId : $vendorId}) {
    nodes {
      landingPath
    }
  }
}
`;

const styleSheet = theme => ({
  tabroot: {
    flexGrow: 1,
    margin: 10,
    width: 'auto',
    borderBottom: '2px solid #dedede',
  },
  tabScrollButton:{
    flex: '0 0 0px'
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'left',
    maxWidth: 1200
  },
  previewPaper: {
    padding: theme.spacing(2),
  },
  visibility: {
    width: 120,
    marginTop: 4,
    marginBottom: 4
  },
  form: {
    width: 200,
    marginTop: 4,
    marginBottom: 4
  },
  formTableText: {
    maxWidth: 200,
    overflowX: 'hidden',
    textOverflow: 'ellipsis',
    //want whitespace to wrap?
    // whiteSpace: 'nowrap'
  },
  /* Screen size specific styles */
  [theme.breakpoints.up('xs')]: {
    tabContainer: {
      padding: 5,
      overflow: 'hidden'
    },
    tableCellPadding: {
      paddingLeft: `6px`,
      paddingRight: `14px`,
    },
    tab: {
      fontSize: 'xx-small',
    },
    labelContainer: {
      paddingLeft: 4,
      paddingRight: 4,
    },
    label: {
      fontSize: 'xx-small',
    },
    labelWrapped: {
      fontSize: 'xx-small',
    },
    tabIcon: {
      fontSize: 24,
    }
  },
  [theme.breakpoints.up('sm')]: {
    tabContainer: {
      padding: 10,
      overflow: 'hidden'
    },
    tableCellPadding: {
      paddingLeft: `12px`,
      paddingRight: `28px`,
    },
    tab: {
      fontSize: 'x-small',
    },
    labelContainer: {
      paddingLeft: 8,
      paddingRight: 8,
    },
    label: {
      fontSize: 'x-small',
    },
    labelWrapped: {
      fontSize: 'x-small',
    },
    tabIcon: {
      fontSize: 24,
    }
  },
  [theme.breakpoints.up('md')]: {
    tabContainer: {
      padding: 20,
      overflow: 'hidden'
    },
    tableCellPadding: {
      paddingLeft: `24px`,
      paddingRight: `56px`,
    },
    tab: {
      fontSize: '0.75rem',
    },
    labelContainer: {
      paddingLeft: 12,
      paddingRight: 12,
    },
    label: {
      fontSize: '0.75rem',
    },
    labelWrapped: {
      fontSize: '0.75rem',
    },
    tabIcon: {
      fontSize: 24,
    }
  },
  //styles for the snackbar
  close: {
    padding: theme.spacing(0.5),
  },    
  success: {
      backgroundColor: green[300],
  },
  error: {
      backgroundColor: theme.palette.error.light,
  },
  icon: {
      fontSize: 20,
  },
  iconVariant: {
      opacity: 0.9,
      marginRight: theme.spacing(1),
  },
  message: {
      display: 'flex',
      alignItems: 'center',
  },
});

function TabContainer(props) {
  const classes = props.classes;
  return <div className={classes.tabContainer}>{props.children}</div>;
}

class ProgramSettingsAdmin extends Component {

  constructor(props) {
    super(props);

    this.state = {
      tabValue: 0,
      showSpinner: false,
      description: null,
      programName: null,
      visibility: null,
      notes: null,
      formId: null,
      repFname: null,
      repLname: null,
      repEmail: null,
      repImg: null,
      defaultParmValue: null,
      showFormCreate: false,
      createFormName: null,
      createFormTitle: null,
      createFormSubtitle: null,
      createFormDescription: '',
      snackbarMessage: null,
      snackbarStatus: null,
      snackbarOpen: null,
      snackbarDuration: null,
      forceFetch: 0,
      previewFormId: null,
      deleteFormConfirm: false,
      previewStage: 0
    }
  }

  handleTabChange = (event, value) => {
    this.setState({ tabValue: value });
  }

  handleTabStageChange = (event, value) => {
    this.setState({ previewStage: value });
  }

  getValueForRender(state_member, prop_member, theDefault)
  {
    if (state_member != null)
      return state_member;

    if (prop_member != null)
      return prop_member;

    return theDefault;
  }

  getValueForFormIdRender(state_member, prop_member)
  {
    if (state_member != null)
      return state_member;

    if (prop_member != null)
      return prop_member;

    if (prop_member == null && state_member == null) {
      return -1;
    }
  }

  getValueForVisibilityRender(propVisibility) {
    if (this.state.visibility != null) {
      return this.state.visibility;
    }

    if (propVisibility != null) {
      return propVisibility;
    }

    return 0;
  }

  showSpinner() {
    return this.state.showSpinner;
  }

  disableProgramSave(theProgram) {
    if (theProgram === null)
       return true;

    // disableAttributeCheck returns false if something is ready to save.  So if anything is
    // ready to save, retval will be false.
    let retval = this.disableAttributeCheck(this.state.description,  theProgram.description, false) &&
                 this.disableAttributeCheck(this.state.programName,    theProgram.programName, false) &&
                 this.disableAttributeCheck(this.state.visibility,     theProgram.visibility, false) &&
                 this.disableAttributeCheck(this.state.notes,        theProgram.notes, false) &&
                 this.disableAttributeCheckFormId(this.state.formId,     theProgram.formId) &&
                 this.disableAttributeCheck(this.state.repFname,     theProgram.repFname, true) &&
                 this.disableAttributeCheck(this.state.repLname,         theProgram.repLname, true) &&
                 this.disableAttributeCheck(this.state.repEmail,         theProgram.repEmail, true) &&
                 this.disableAttributeCheck(this.state.repImg,        theProgram.repImg, false) &&
                 this.disableAttributeCheck(this.state.defaultParmValue,      theProgram.defaultParmValue, false);

    return retval;
  }


  /*
   * The attribute isn't ready for saving unless something
   * has changed.  
   * 
   * A return of false means something has changed (don't disable).
   * 
   */
  disableAttributeCheck(stateVar, propsVar, allowEmptyString)
  {
      if (stateVar !== null)
      {
          if (propsVar === null && stateVar === '')
              return true;

          if ((propsVar !== null && propsVar !== '') && stateVar === '') {
            if (allowEmptyString) {
              return false;
            } else {
              return true;
            }
          }

          if (propsVar !== stateVar)
              return false;
      }
      return true;
  }

  disableAttributeCheckFormId(stateVar, propsVar, allowEmptyString)
  {
      if (stateVar === -1 && propsVar == null) {
        //special case for nulling out form id insanity
        return true;
      }

      if (stateVar !== null)
      {
          if (propsVar === null && stateVar === '')
              return true;

          if ((propsVar !== null && propsVar !== '') && stateVar === '') {
            if (allowEmptyString) {
              return false;
            } else {
              return true;
            }
          }

          if (propsVar !== stateVar)
              return false;
      }
      return true;
  }

  editForm(formId) {
    //open the page to edit the form based off the ID 
    let accountId = abEnvironment.getUserAttribute('a_id');
    this.props.history.push('/formEdit?formId=' + formId + '&accountId=' + accountId);
  }

  openFormCreateDialog = () => {
    this.setState({
      showFormCreate: true
    });
  };

  closeFormCreateDialog = () => {
    this.setState({
      showFormCreate: false
    });
  };

  showSnackbar = (status, message, duration) => {
    this.setState({
      snackbarStatus: status,
      snackbarMessage: message,
      snackbarDuration: duration,
      snackbarOpen: true 
    })
  };
  
  closeSnackbar() {
    this.setState({
      snackbarOpen: false,
      snackbarMessage: null,
      snackbarDuration: null,
    })
  }

  render() {
    const { isAuthenticated, isAuthenticatedVendor, needAssent, logError } = this.props.auth;
    const classes = this.props.classes;

    if (!isAuthenticated() || needAssent()) {
      return (
        <Redirect to='/home' />
      );
    }

    if (isAuthenticatedVendor())
    {
      let accountId = abEnvironment.getUserAttribute('a_id');

      return (
        <div>
          <QueryRenderer
            environment={abEnvironment.getEnvironment()}
            query={ProgramSettingsAdminQuery}
            variables={{vendorId: accountId, forceFetch: this.state.forceFetch}}
            render={({error, props})=> {
              if (error) {
                logError(error.message);
                return (
                  <ServerError/>
                );
              } else if (props) {
                let theProgram = null;
                if (props.allVppTs.totalCount > 0) {
                  theProgram = props.allVppTs.nodes[0];
                }
                let theProgramForms = props.allFormTs.nodes;
                let theAccountLandings = props.allAccountLandingTs.nodes;

                return (
                  <div className={classes.root}>
                    <PageTitle title="Program settings" subtitle="Settings to fine tune your program"/>
                    
                      { (theProgram == null) &&
                        <Typography variant="body2">There is no program defined yet.  Please contact AppBind support.</Typography>
                      }

                      { (theProgram != null) &&
                      <Paper className={classes.paper}>
                        <Grid container spacing={2} justifyContent="space-between">
                        <Grid item xs={12}>
                            <Tabs
                              value={this.state.tabValue}
                              onChange={this.handleTabChange}
                              indicatorColor="primary"
                              textColor="primary"
                              variant="fullWidth"
                              scrollButtons="auto"
                              classes={{root: classes.tabroot, scrollButtons: classes.tabScrollButton}}
                            >
                              <Tab label="Program"
                                icon={<Settings className={classes.tabIcon} />}
                                classes={{
                                    root: classes.tab,
                                    wrapper: classes.labelWrapped,
                                 }}/>
                              <Tab label="Forms"
                                icon={<FormatListNumberedIcon className={classes.tabIcon} />}
                                classes={{
                                    root: classes.tab,
                                    wrapper: classes.labelWrapped,
                                 }}/>
                              {/* 
                              <Tab label="Assets"
                                icon={<AccountBalanceIcon className={classes.tabIcon} />}
                                classes={{
                                    root: classes.tab,
                                    wrapper: classes.labelWrapped,
                                 }}/>
                              */}
                              <Tab label="Page"
                                icon={<ArticleIcon className={classes.tabIcon} />}
                                classes={{
                                    root: classes.tab,
                                    wrapper: classes.labelWrapped,
                                 }}/>
                              
                            </Tabs>
                          </Grid>

                          {this.state.tabValue === 0  &&
                            <TabContainer {...this.props}>
                               <Grid container spacing={2} justifyContent="flex-start">
                                <Grid item xs={12} sm={6}>
                                  <TextField 
                                    id="programName" label="Program name"
                                    value={ this.getValueForRender(this.state.programName, theProgram.programName, '') }
                                    onChange={ (e) => this.setState({ programName: e.target.value }) }
                                    inputProps={{ maxLength: 64 }}
                                  />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                  <TextField 
                                    id="description" label="Description"
                                    value={ this.getValueForRender(this.state.description, theProgram.description, '') }
                                    onChange={ (e) => this.setState({ description: e.target.value }) }
                                    inputProps={{ maxLength: 2048 }}
                                  />
                                </Grid>

                                <Grid item xs={12}> 
                                  <FormControl variant="standard" >
                                    <InputLabel htmlFor={'Visibility'} >{'Visibility'}</InputLabel>
                                    <Select
                                      value={this.getValueForVisibilityRender(theProgram.visibility) }
                                      className={classes.visibility}
                                      onChange={(e) => { 
                                            this.setState({ visibility: e.target.value }); 
                                      } }
                                      inputProps={{
                                        name: 'visibility',
                                        id: 'visibility',
                                      }}
                                    >
                                      <MenuItem value={0}>Private</MenuItem>
                                      <MenuItem value={1}>Invite only</MenuItem>
                                      <MenuItem value={2}>Public</MenuItem>
                                    </Select>
                                  </FormControl>
                                </Grid>
                                <Grid item xs={12} >
                                  <TextField 
                                    id="notes" label="Notes"
                                    value={ this.getValueForRender(this.state.notes, theProgram.notes, '') }
                                    onChange={ (e) => this.setState({ notes: e.target.value }) }
                                    inputProps={{ maxLength: 2048 }}
                                  />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                  <TextField 
                                    id="representativeFName" label="Representative first name"
                                    value={ this.getValueForRender(this.state.repFname, theProgram.repFname, '') }
                                    onChange={ (e) => this.setState({ repFname: e.target.value }) }
                                    inputProps={{ maxLength: 32 }}
                                  />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                  <TextField 
                                    id="representativeLName" label="Representative last name"
                                    value={ this.getValueForRender(this.state.repLname, theProgram.repLname, '') }
                                    onChange={ (e) => this.setState({ repLname: e.target.value }) }
                                    inputProps={{ maxLength: 32 }}
                                  />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                  <TextField 
                                    id="representativeEmail" label="Representative email"
                                    value={ this.getValueForRender(this.state.repEmail, theProgram.repEmail, '') }
                                    onChange={ (e) => this.setState({ repEmail: e.target.value }) }
                                    inputProps={{ maxLength: 254 }}
                                  />
                                </Grid>
                                <Grid item xs={12}> 
                                  <FormControl variant="standard" >
                                    <InputLabel htmlFor={'ApplicationForm'} >{'Application form'}</InputLabel>
                                    <Select
                                      value={this.getValueForFormIdRender(this.state.formId, theProgram.formId, -1) }
                                      className={classes.form}
                                      onChange={(e) => { 
                                         this.setState({ formId: e.target.value }); 
                                      } }
                                      inputProps={{
                                        name: 'formId',
                                        id: 'formId',
                                      }}
                                    >      
                                    
                                    <MenuItem value={-1}>{'None'}</MenuItem>
                                    { theProgramForms.map(n => {       
                                      return (<MenuItem value={n.formId} key={n.formId}>{n.formName}</MenuItem>);
                                    })}
                                    </Select>
                                  </FormControl>
                                </Grid>

                                <Grid item xs={12}> 
                                  <FormControl variant="standard" >
                                    <InputLabel htmlFor={'Landing path'} >{'Landing path'}</InputLabel>
                                    <Select
                                      value={this.getValueForRender(this.state.defaultParmValue, theProgram.defaultParmValue) }
                                      className={classes.form}
                                      onChange={(e) => { 
                                            this.setState({ defaultParmValue: e.target.value }); 
                                      } }
                                      inputProps={{
                                        name: 'landingPath',
                                        id: 'landingPath',
                                      }}
                                    >
                                      <MenuItem
                                        value={this.getValueForRender(this.state.defaultParmValue, theProgram.defaultParmValue)}
                                        key='default-home'>
                                          {this.getValueForRender(this.state.defaultParmValue, theProgram.defaultParmValue)}
                                      </MenuItem>
                                      { theAccountLandings.map(n => {
                                        return (<MenuItem value={n.landingPath} key={n.landingPath}>{n.landingPath}</MenuItem>);
                                      })}
                                    </Select>
                                  </FormControl>
                                </Grid>
                                <Grid item xs={12}>
                                  { !this.showSpinner() &&
                                  <Button disabled={this.disableProgramSave(theProgram)} variant="contained" color="primary"  style={AppBindStyles.bottomButton}
                                    onClick={() => {this.updateProgram(theProgram);}}>
                                    Save
                                  </Button> }
                                  {this.showSpinner() &&
                                  <Button color="primary" variant="contained"  style={AppBindStyles.bottomButton} >
                                    <SavingSpinner/>
                                  </Button>
                                  }
                                    
                                </Grid>
                                </Grid>
                         </TabContainer>}

                        {this.state.tabValue === 1  &&
                        <TabContainer {...this.props}>
                          <Grid container spacing={2} justifyContent="flex-start">

                            <Grid item xs={12}>
                              {/* <Typography>Coming soon</Typography> */}
                              <Button color='primary'
                                variant='contained'
                                onClick={this.openFormCreateDialog}
                                >
                                Create form
                              </Button>
                            </Grid>
                            <Grid item xs={12} style={{overflowX: 'auto'}}>
                              {/* table of form entries with link to edit on the name */}
                              <Table size="small" >
                                <TableHead>
                                  <TableRow>
                                    <TableCell>Form Name</TableCell>
                                    <TableCell>Form Subtitle</TableCell>
                                    <TableCell>Created</TableCell>
                                    <TableCell>Updated</TableCell>
                                    <TableCell>View</TableCell>
                                    <TableCell>Delete</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {
                                    theProgramForms.map(n => {

                                      //massage fields from the form so they look okay
                                      let createdDate = new Date(n.created + 'Z');
                                      let updatedDate = new Date(n.updated + 'Z');

                                      return(
                                      <TableRow key={n.formId}>
                                        <TableCell className={classes.formTableText}>
                                          <Link component='button'
                                            variant='body2'
                                            className={classes.formEditLink}
                                            style={{textAlign:'left'}}
                                            onClick={() => {this.editForm(n.formId)}}>
                                              {n.formName}
                                          </Link>
                                        </TableCell>
                                        <TableCell className={classes.formTableText}>{n.formSubtitle}</TableCell>
                                        <TableCell>{createdDate.toDateString()}</TableCell>
                                        <TableCell>{updatedDate.toDateString()}</TableCell>
                                        <TableCell>
                                          <Button
                                           onClick={ () => this.setState({ previewFormId: n.formId }) }
                                           ><Pageview /></Button>
                                        </TableCell>
                                        <TableCell>
                                          <Button
                                            onClick={ () => this.setState({ deleteFormConfirm: true, formToDelete: n.formId }) }
                                            ><Delete /></Button>
                                        </TableCell>
                                      </TableRow>
                                      );
                                    })
                                  }
                                </TableBody>
                              </Table>
                            </Grid>
                              
                          </Grid>

                          <FormCreateDialog 
                            open={this.state.showFormCreate}
                            showSnackbar={ (status,message,duration) => { this.showSnackbar(status,message,duration); } }
                            hideSnackbar={ () => { this.closeSnackbar(); } }
                            onClose={ () => {this.closeFormCreateDialog()}}
                            formSaveStatus={this.state.snackbarStatus}
                            onChange={ () => {this.setState({ snackbarStatus: null })} }
                            onSaveSuccess={ (formId) => {
                              this.showSnackbar('success', 'New form successfully created', 3000);
                              
                              //instead of "go back to this page," instead go to editing the new form
                              if (formId)
                                this.props.history.push('/FormEdit?formId=' + formId);
                            } }
                            accountId={accountId} 
                            props={this.props}
                            auth={this.props.auth} />
                 
                          {/* preview form dialog... */}
                          <Dialog maxWidth={false}
                            open={this.state.previewFormId !== null}
                            onClose={ () => this.setState({ previewFormId: null }) }>
                            <DialogTitle>
                              <Grid container spacing={2} justifyContent='space-between'>
                                <Grid item>
                                  <Typography variant='h6'>This is a preview of the form</Typography>
                                </Grid>
                                <Grid item>
                                  <Typography>
                                    <IconButton size="small"
                                      style={{ float: 'right', margin: '5px' }}
                                      onClick={() => {
                                        this.setState({ previewFormId: null });
                                      }}
                                    ><Close /></IconButton>
                                  </Typography>
                                </Grid>
                              </Grid>
                            </DialogTitle>
                            <DialogContent>
                              { this.state.previewFormId &&
                              <FormPreview formId={this.state.previewFormId} auth={this.props.auth} />
                              }
                            </DialogContent>
                          </Dialog>

                          <ConfirmationDialog
                            open={this.state.deleteFormConfirm}
                            onClose={() => this.setState({ deleteFormConfirm: false, formToDelete: null }) }
                            onConfirm={() => this.deleteForm(this.state.formToDelete) }
                            onCancel={() => { }}
                            title="Delete form?"
                            cancelBtn="Cancel"
                            okBtn="Ok"
                            irreversibleAction={true}
                          >
                            
                          </ConfirmationDialog>  
                        </TabContainer>}

                        {/*
                        {this.state.tabValue === 2  &&
                        <TabContainer {...this.props}>
                          <Grid container spacing={2} justifyContent="flex-start">
                            <Grid item xs={12}>
                              <ProgramSettingsAsset
                                vppId={theProgram.vppId}
                                auth={this.props.auth}
                                history={this.props.history}/>
                            </Grid>
                          </Grid>
                        </TabContainer>}
                         */}

                        {this.state.tabValue === 2 &&
                        <TabContainer {...this.props}>
                          <Grid container spacing={2} justifyContent="flex-start">
                            <Grid item xs={12}>
                              <Grid container spacing={0} direction="row" justifyContent="flex-start">
                                <Grid item xs={12}>
                                  <Typography align="left" variant="h6">Partner page</Typography>
                                </Grid>                          
                                <Grid item xs={12}>
                                  <Typography variant="body2">Manage and preview the partner page in each stage</Typography>
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid item xs={12}>
                              <Tabs
                                value={this.state.previewStage}
                                onChange={this.handleTabStageChange}
                                indicatorColor="primary"
                                textColor="primary"
                                variant="fullWidth"
                                scrollButtons="auto"
                                classes={{root: classes.tabroot, scrollButtons: classes.tabScrollButton}}
                              >
                                <Tab label="Lead"
                                  classes={{
                                      root: classes.tab,
                                      wrapper: classes.labelWrapped,
                                  }}/>
                                <Tab label="Applied"
                                  classes={{
                                      root: classes.tab,
                                      wrapper: classes.labelWrapped,
                                  }}/>
                                <Tab label="Active"
                                  classes={{
                                      root: classes.tab,
                                      wrapper: classes.labelWrapped,
                                  }}/>
                                <Tab label="Suspended"
                                  classes={{
                                      root: classes.tab,
                                      wrapper: classes.labelWrapped,
                                  }}/>
                                <Tab label="Rejected"
                                  classes={{
                                      root: classes.tab,
                                      wrapper: classes.labelWrapped,
                                  }}/>
                              </Tabs>

                              <TabContainer {...this.props}>
                                <ProgramSettingsStage
                                    vppId={theProgram.vppId}
                                    vpp={theProgram}
                                    stage={this.state.previewStage}
                                    auth={this.props.auth}
                                    history={this.props.history}/>
                              </TabContainer>
                            </Grid>
                            {/* 
                            <Grid item xs={12}>
                              <FormControl variant="standard" >
                                <InputLabel htmlFor='Stage'>Stage</InputLabel>
                                <Select
                                  value={this.state.previewStage}
                                  className={classes.visibility}
                                  onChange={(e) => { 
                                    this.setState({ previewStage: e.target.value }); 
                                  } }
                                  inputProps={{
                                    name: 'stage',
                                    id: 'stage',
                                  }}
                                >
                                  <MenuItem value={0}>0 - Lead</MenuItem>
                                  <MenuItem value={1}>1 - Applied</MenuItem>
                                  <MenuItem value={2}>2 - Active</MenuItem>
                                  <MenuItem value={3}>3 - Suspended</MenuItem>
                                  <MenuItem value={4}>4 - Rejected</MenuItem>
                                  <MenuItem value={5}>5 - Left</MenuItem>
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                              <Paper className={classes.previewPaper}>
                                <VendorPartnerProgram
                                  mode='dev'
                                  vppId={theProgram.vppId}
                                  stage={this.state.previewStage}
                                  auth={this.props.auth}
                                  history={this.props.history}/>
                              </Paper>
                            </Grid>
                            */}
                          </Grid>
                        </TabContainer>}
                      </Grid>
                    </Paper>}
                  </div>
                )
              }
              return (
                <div>
                  <LoadingSpinner/>
                </div>
              );
            }}
          />
          {/* snackbar outside query renderer to avoid "reload" eating the message */}
          <Snackbar
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            open={this.state.snackbarOpen}
            autoHideDuration={this.state.snackbarDuration}
            onClose={ () => { this.closeSnackbar() }}
          >
            <SnackbarContent
              className={classNames(classes.message, classes[this.state.snackbarStatus])}
              onClose={ () => { this.closeSnackbar() }}
              message={
                <Typography variant="body1">
                  {this.state.snackbarMessage}
                </Typography>
              }
              action={[
                <IconButton
                  key="close"
                  aria-label="Close"
                  color="inherit"
                  className={classes.close}
                  onClick={ () => { this.closeSnackbar() }}
                  size="large">
                  <CloseIcon />
                </IconButton>
              ]}
            />
          </Snackbar>
        </div>
      );
    }
    else
    {
      return (
        <Redirect to='/home' />
      );
    }
  }

  updateProgram(theProgram) {
    this.setState({ showSpinner: true });
    const { description, programName, visibility, notes, formId, repFname, repLname, repEmail, repImg, defaultParmValue, forceFetch } = this.state;
  
    VppUpdateMutation.commit(theProgram.vppId, description, programName, visibility, notes, formId, repFname, repLname, repEmail, repImg, defaultParmValue)
    .then(response => {
      // console.log('Account updated')
      let ff = forceFetch;
      ff++;
      this.setState({ showSpinner: false, forceFetch: ff }); 
  
     })
    .catch(error => {
      // console.log('Got error: ' + error);
      this.setState({ showSpinner: false });
    });
  }

  deleteForm(theFormId) {
    //delete sub formDetails... but before the formDetails delete the formDetailValues

    FormDeleteMutation.commit(theFormId)
    .then( response => {
      let reFetch = this.state.forceFetch;
      reFetch++;
      this.setState({ deleteFormConfirm: false, formToDelete: null, forceFetch: reFetch });
    }).catch( error => {
      console.log(error);
      this.setState({ deleteFormConfirm: false, formToDelete: null });
    });
  }
}

export default withStyles(styleSheet)(ProgramSettingsAdmin);
